<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24"> </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        class="j-table-force-nowrap"
        :scroll="{ x: true }"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, type: 'radio' }"
        :customRow="clickThenSelect"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无图片</span>
          <img
            v-else
            :src="getImgView(text)"
            height="25px"
            alt=""
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无文件</span>
          <a-button v-else :ghost="true" type="primary" icon="download" size="small" @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <OkrPlanList :mainId="selectedMainId" :mainRow="selectionRows[0]" />
    <!-- <a-row
      ><a-col :span="12">
        <a-tabs defaultActiveKey="1">
          <a-tab-pane tab="双月复盘-工作计划" key="1">
            <OkrPlanList :mainId="selectedMainId" :mainRow="selectionRows[0]" />
          </a-tab-pane>
        </a-tabs>
      </a-col>
      <a-col :span="12">
        <a-tabs defaultActiveKey="1">
          <a-tab-pane tab="双月复盘-工作计划-修订" key="1">
            <OkrPlanReviseList :mainId="selectedMainId" :mainRow="selectionRows[0]" />
          </a-tab-pane>
        </a-tabs> </a-col
    ></a-row> -->

    <okrSummary-modal ref="modalForm" @ok="modalFormOk"></okrSummary-modal>
  </a-card>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import OkrSummaryModal from './modules/OkrSummaryModal'
import { getAction } from '@/api/manage'
import OkrPlanList from './OkrPlanList'
import OkrPlanReviseList from './OkrPlanReviseList'
import { initDictOptions, filterMultiDictText } from '@/components/dict/JDictSelectUtil'
import '@/assets/less/TableExpand.less'

export default {
  name: 'OkrSummaryList',
  mixins: [JeecgListMixin],
  components: {
    OkrPlanList,
    OkrPlanReviseList,
    OkrSummaryModal,
  },
  data() {
    return {
      description: '双月复盘-总结管理页面',
      // 表头
      columns: [
        {
          title: '复盘时间',
          align: 'center',
          dataIndex: 'okrGroupIdDictText',
        },
        {
          title: '分配给',
          align: 'center',
          dataIndex: 'createByDictText',
        },
        {
          title: '汇报对象',
          align: 'center',
          dataIndex: 'reporterText',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: `${window._CONFIG['doBaseUrl']}/doMistServer/okrSummary/list2`,
        delete: `${window._CONFIG['doBaseUrl']}/doMistServer/okrSummary/delete`,
        deleteBatch: `${window._CONFIG['doBaseUrl']}/doMistServer/okrSummary/deleteBatch`,
        exportXlsUrl: `${window._CONFIG['doBaseUrl']}/doMistServer/okrSummary/exportXls`,
        importExcelUrl: `${window._CONFIG['doBaseUrl']}/doMistServer/okrSummary/importExcel`,
      },
      dictOptions: {
        okrGroupId: [],
      },
      /* 分页参数 */
      ipagination: {
        current: 1,
        pageSize: 5,
        pageSizeOptions: ['5', '10', '50'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      selectedMainId: '',
      superFieldList: [],
    }
  },
  created() {
    this.getSuperFieldList()
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    initDictConfig() {
      initDictOptions('okr_group,name,id').then((res) => {
        if (res.success) {
          this.$set(this.dictOptions, 'okrGroupId', res.result)
        }
      })
    },
    clickThenSelect(record) {
      return {
        on: {
          click: () => {
            this.onSelectChange(record.id.split(','), [record])
          },
        },
      }
    },
    onClearSelected() {
      this.selectedRowKeys = []
      this.selectionRows = []
      this.selectedMainId = ''
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedMainId = selectedRowKeys[0]
      this.selectedRowKeys = selectedRowKeys
      this.selectionRows = selectionRows
    },
    loadData(arg) {
      if (!this.url.list) {
        this.$message.error('请设置url.list属性!')
        return
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      this.onClearSelected()
      var params = this.getQueryParams() //查询条件
      this.loading = true
      getAction(this.url.list, params).then((res) => {
        if (res.success) {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
        }
        if (res.code === 510) {
          this.$message.warning(res.message)
        }
        this.loading = false
      })
    },
    getSuperFieldList() {
      let fieldList = []
      fieldList.push({ type: 'string', value: 'okrGroupId', text: '复盘时间', dictCode: 'okr_group,name,id' })
      fieldList.push({ type: 'sel_user', value: 'assignner', text: '分配给' })
      fieldList.push({ type: 'sel_user', value: 'reporter', text: '汇报对象' })
      this.superFieldList = fieldList
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
